import CsToolArenaSegmentScreen from './arena-segment';

export default CsToolArenaSegmentScreen;
